import { FC } from 'react'
import { noop } from 'lodash'

import { Tab as MuiTab } from '@mui/material'
import MuiTabs from '@mui/material/Tabs'

import { TabsContainer } from './styles'
import { TabsProps } from './types'

const Tabs: FC<TabsProps> = ({
  selectedTabValue,
  onChange = noop,
  tabs,
  variant = 'standard',
  ariaLabel,
  tabAriaLabel,
  containerStyle = {}
}) => (
  <TabsContainer sx={{ width: '100%', ...containerStyle }}>
    <MuiTabs
      variant={variant}
      value={selectedTabValue}
      onChange={(_e, newValue): void => {
        onChange(newValue)
      }}
      aria-label={ariaLabel || 'tabs'}
    >
      {tabs.map((tab) => {
        return (
          <MuiTab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            aria-label={tabAriaLabel || 'tab'}
          />
        )
      })}
    </MuiTabs>
  </TabsContainer>
)

export default Tabs
